import { authRoles } from '@ameroservices-platform/loppe-boothownerui/app/auth';
import store from '@ameroservices-platform/loppe-boothownerui/app/store';
import { logoutUser } from '@ameroservices-platform/loppe-boothownerui/app/auth/store/userSlice';

const LogoutConfig = {
	auth: authRoles.user,
	routes: [
		{
			path: 'logout',
			element: () => {
				store.dispatch(logoutUser());
				return 'Logging out..';
			},
		},
	],
};

export default LogoutConfig;
